module.exports = __webpack_public_path__ + "img/chevron_right.0ddf47fb.svg";